module.exports = __webpack_public_path__ + "img/sofa.0a4f963d.png";